/*global eclipseApp, $, _, angular*/
(function () {

  'use strict';

  angular
    .module('eclipseApp.autoRegSetPassword')
    .controller('autoRegSetPasswordFormCtrl', AutoRegSetPasswordFormCtrl);

  AutoRegSetPasswordFormCtrl.$inject = ['setPasswordService'];

  function AutoRegSetPasswordFormCtrl(setPasswordService) {

    var ctrl = this;

    init();

    function init() {
      ctrl.getUsername = setPasswordService.getUsername;
      ctrl.hasSystemError = false;

      ctrl.config = {
        isUsernameCollapsed: true,
        formControl: {
          username: '',
          password: '',
          confirmPassword: ''
        },
        fieldTypes: {
          password: false,
          confirmPassword: false
        }
      };
    }

    ctrl.setPasswordInputType = function (key) {
      if (key === 'password') {
        ctrl.config.fieldTypes.password = !ctrl.config.fieldTypes.password;
        angular.element('#password').focus();
      } else {
        ctrl.config.fieldTypes.confirmPassword = !ctrl.config.fieldTypes.confirmPassword;
        angular.element('#confirmPassword').focus();
      }
    };

    ctrl.toggleEditUsername = function () {
      ctrl.config.isUsernameCollapsed = !ctrl.config.isUsernameCollapsed;
    };

    ctrl.closeEditUsername = function () {
      ctrl.config.isUsernameCollapsed = true;
    };

    ctrl.updateUsername = function (form) {
      if (ctrl.config.formControl.username && setPasswordService.isEmailTaken(ctrl.config.formControl.username)) {
        form.username.$setValidity('taken', false);
        ctrl.usernameUpdateStatus = 'fail';
      } else if (form.username.$error.taken) {
        form.username.$setValidity('taken', true);
      }
      ctrl.hasSystemError = false;

      if (form.$valid) {
        ctrl.usernameUpdateStatus = null;
        ctrl.config.usernameIsUpdating = true;
        setPasswordService.updateUsername(ctrl.config.formControl.username)
          .then(function () {
            ctrl.usernameUpdateStatus = 'success';
          })
          .catch(function (response) {
            ctrl.usernameUpdateStatus = 'fail';
            if (response === '400.002') {
              form.username.$setValidity('taken', false);
            } else {
              ctrl.hasSystemError = true;
            }
          })
          .finally(function () {
            ctrl.config.usernameIsUpdating = false;
          });
      }
    };

    ctrl.setPassword = function (form) {
      ctrl.hasSystemError = false;
      if (form.$valid) {
        setPasswordService.setPassword(ctrl.config.formControl.password, ctrl.config.formControl.confirmPassword)
          .catch(function () {
            ctrl.hasSystemError = true;
          });
      }
    };

    ctrl.getUpdateBtnKey = function () {
      if (ctrl.config.usernameIsUpdating) {
        return 'global.label.setAutoRegistrationPassword.button.update.updating';
      } else if (ctrl.usernameUpdateStatus === 'success') {
        return 'global.label.setAutoRegistrationPassword.button.update.updated';
      } else if (ctrl.usernameUpdateStatus === 'fail') {
        return 'global.label.setAutoRegistrationPassword.button.update.retry';
      } else {
        return 'global.label.setAutoRegistrationPassword.button.update.update';
      }
    };

    ctrl.getUpdateBtnClass = function () {
      if (ctrl.config.usernameIsUpdating) {
        return 'updating-btn';
      } else if (ctrl.usernameUpdateStatus === 'success') {
        return 'updated-btn';
      } else if (ctrl.usernameUpdateStatus === 'fail') {
        return 'retry-btn';
      }
    };
  }
})();
